/**
 * UranIA PA — `/console/ingestion` (redirect a `/admin/corpus/ingestione`).
 *
 * Fusione A.4.5 (Riordino della mappa delle rotte §4). `IngestionPage`
 * (il componente che viveva qui) è stata rimossa, non solo scollegata:
 * era un mock senza chiamate API reali (stesso handoff esterno di
 * `/console`), e `/admin/corpus/ingestione` porta la pipeline RAG
 * reale — tenerla in giro come pagina alternativa avrebbe significato due
 * "code di ingestion" duplicate, una vera e una finta (decisione
 * confermata dall'utente 2026-09-07, vedi `admin/corpus/ingestione/index.tsx`).
 */

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as AmministrazioneSegmentRoute } from './_amministrazione.tsx';

export const Route = createRoute({
  getParentRoute: () => AmministrazioneSegmentRoute,
  path: '/console/ingestion',
  beforeLoad: () => {
    throw redirect({ to: '/admin/corpus/ingestione', replace: true });
  },
});
